import React, { useEffect, useState } from "react";
import Table from "../../../components/ui/Table";
import {
    AccountCreationRequestMotherName,
    isAccountCreationRequest,
    isAdminAbleToChangeUsersEmail,
    isAdminAbleToChangeUsersFatherPhone,
    isAdminAbleToChangeUsersFullName,
    isAdminAbleToChangeUsersGovernment,
    isAdminAbleToChangeUsersMotherPhone,
    isAdminAbleToChangeUsersPhone,
    isMultiYear,
} from "../../../services/defaultSettings";
import { printFullDate } from "../../../utils/time";

import { getYearPlaceHolder, years } from "../../../services/yearSevices";
import { Link } from "react-router-dom";
import { printIdOfOptions } from "../../../utils/ar";
import http from "../../../services/httpServices";
import modal from "../../../services/modalServices";
import Button from "../../../components/ui/Button";
import { baseURL } from "../../../config";
import auth from "../../../services/authServices";
import modal2 from "../../../services/modal2Services";

const ShowUser = ({ user, afterSuccess }) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmitChaningUserData = async (user_key, user_value) => {
        setIsLoading(true);
        try {
            const token = auth.getAdminToken();
            const config = auth.getAdminAuthConfig(token);
            if (user_key === "father_phone" || user_key === "mother_phone") {
                user_value = parseInt(user_value);
            }
            const dataToSend = { user_key, user_value };

            const { data } = await http.post(
                `/api/admin/users/${user[0].id}/admin_edit_user_data`,
                dataToSend,
                config
            );
            modal.message({
                title: "تم التعديل بنجاح",
                icon: "success",
            });

            afterSuccess();
            setIsLoading(false);
        } catch ({ response }) {
            let errors = response.data.errors;
            let error = "";
            for (let key in errors) {
                error += errors[key] + "\n";
            }
            if (error === "") {
                error = response.data.message;
            }

            modal.message({
                title: "حدث خطأ",
                text: error,
                icon: "error",
            });

            setIsLoading(false);
        }
    };
    const showChangingInputModal = (user_key, text) => {
        let governmentsOptions = {};
        governments.forEach((government) => {
            governmentsOptions[government.value] = government.text;
        });
        let yearsOptions = {};
        years.forEach((year) => {
            if (year.value == 4) {
                return;
            }
            yearsOptions[year.value] = year.text;
        });

        modal2.message({
            title: "هل انت متأكد؟",
            input:
                user_key === "gender" || user_key === "government_id" || user_key === "year"
                    ? "select"
                    : "text",
            inputOptions:
                user_key === "government_id"
                    ? governmentsOptions
                    : user_key === "gender"
                    ? { male: "ذكر", female: "انثى" }
                    : user_key === "year"
                    ? yearsOptions
                    : null,
            inputLabel: text,
            inputValue: user[0][user_key],
            inputValidator: (value) => {
                if (!value) {
                    return "يجب عليك كتابه القيمة";
                }
            },
            icon: "warning",
            confirmButtonText: "تنفيذ",
            cancelButtonText: "إلغاء",
            showCancelButton: true,
            callback: async (e) => {
                if (e.isConfirmed) {
                    handleSubmitChaningUserData(user_key, e.value);
                }
            },
        });
    };
    let columns = [
        {
            name: "التسلسل",
            reorder: true,
            selector: (row) => row.id,
        },
        {
            name: "عدد مرات تغير الباسورد",
            reorder: true,
            selector: (row) => row.password_reset_count,
        },
    ];
    if (user[0] && user[0].insert_auto_log_row && user[0].insert_auto_log_row.name) {
        columns = [
            ...columns,
            {
                name: "اسم جدول الأكواد",
                reorder: true,
                selector: (row) => (
                    <>
                        {user[0].insert_auto_log_row.name}
                        <br />
                        id: {user[0].insert_auto_log_row.id}, qty:{" "}
                        {user[0].insert_auto_log_row.quantity}
                    </>
                ),
            },
        ];
    }
    if (user[0] && user[0].charged_to_user) {
        columns = [
            ...columns,
            {
                name: "رقم هاتف المشحون إليه الإشتراك",
                reorder: true,
                selector: (row) => (
                    <Link
                        className="block px-1 py-1 text-center underline"
                        element="Link"
                        to={`../../user_profile/${row.charged_to_user.id}`}
                    >
                        {"0" + row.charged_to_user.phone}
                    </Link>
                ),
            },
        ];
    }
    columns = [
        ...columns,

        {
            name: "الاسم الكامل",
            reorder: true,
            selector: (row) =>
                isAdminAbleToChangeUsersFullName ? (
                    <span className="flex flex-col flex-center-both space-y-2">
                        <span className="inline-block">{row.full_name}</span>
                        <div>
                            <Button
                                color="yellow"
                                className="pb-0.5 px-2"
                                isLoading={isLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    showChangingInputModal("full_name", "تعديل الاسم الكامل");
                                }}
                            >
                                تعديل
                            </Button>
                        </div>
                    </span>
                ) : (
                    row.full_name
                ),
        },
    ];
    columns = [
        ...columns,
        {
            name: "رقم الهاتف",
            reorder: true,
            selector: (row) => row.phone,
        },
        {
            name: "رقم هاتف ولي الأمر",
            reorder: true,
            selector: (row) =>
                isAdminAbleToChangeUsersFatherPhone ? (
                    <span className="flex flex-col flex-center-both space-y-2">
                        <span className="inline-block">{row.father_phone}</span>
                        <div>
                            <Button
                                color="yellow"
                                className="pb-0.5 px-2"
                                isLoading={isLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    showChangingInputModal(
                                        "father_phone",
                                        "تعديل رقم هاتف ولي الأمر"
                                    );
                                }}
                            >
                                تعديل
                            </Button>
                        </div>
                    </span>
                ) : (
                    row.father_phone
                ),
        },
    ];
    if (AccountCreationRequestMotherName) {
        columns = [
            ...columns,

            {
                name: "رقم هاتف الأم",
                reorder: true,
                selector: (row) =>
                    isAdminAbleToChangeUsersMotherPhone ? (
                        <span className="flex flex-col flex-center-both space-y-2">
                            <span className="inline-block">{row.mother_phone}</span>
                            <div>
                                <Button
                                    color="yellow"
                                    className="pb-0.5 px-2"
                                    isLoading={isLoading}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        showChangingInputModal(
                                            "mother_phone",
                                            "تعديل رقم هاتف الأم"
                                        );
                                    }}
                                >
                                    تعديل
                                </Button>
                            </div>
                        </span>
                    ) : (
                        row.mother_phone
                    ),
            },
        ];
    }
    columns = [
        ...columns,
        {
            name: "المحافظة",
            reorder: true,
            selector: (row) =>
                isAdminAbleToChangeUsersGovernment ? (
                    <span className="flex flex-col flex-center-both space-y-2">
                        <span className="inline-block">
                            {printIdOfOptions(governments, row.government_id)}
                        </span>
                        <div>
                            <Button
                                color="yellow"
                                className="pb-0.5 px-2"
                                isLoading={isLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    showChangingInputModal("government_id", "تعديل المحافظة");
                                    // handleChangeUserData("full_name", row.full_name);
                                }}
                            >
                                تعديل
                            </Button>
                        </div>
                    </span>
                ) : (
                    printIdOfOptions(governments, row.government_id)
                ),
            sortable: true,
            sortField: "phone",
        },
    ];
    columns = [
        ...columns,
        {
            name: "البريد الإلكتروني",
            reorder: true,
            selector: (row) =>
                isAdminAbleToChangeUsersEmail ? (
                    <span className="flex flex-col flex-center-both space-y-2">
                        <span className="inline-block">{row.email}</span>
                        <div>
                            <Button
                                color="yellow"
                                className="pb-0.5 px-2"
                                isLoading={isLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    showChangingInputModal("email", "تعديل الأيميل");
                                }}
                            >
                                تعديل
                            </Button>
                        </div>
                    </span>
                ) : (
                    row.email
                ),
        },
    ];
    if (isAccountCreationRequest) {
        columns = [
            ...columns,
            {
                name: "اثبات شخصية",
                reorder: true,
                selector: (row) => (
                    <Button
                        color="blue"
                        onClick={(e) => {
                            e.preventDefault();
                            modal.message({ icon: `${baseURL}/${row.national_id_copy}` });
                        }}
                        className=""
                    >
                        عرض الصورة
                    </Button>
                ),
                sortable: true,
                sortField: "national_id_copy",
            },
        ];
    }
    if (isMultiYear) {
        columns.push({
            name: "العام الدراسي",
            reorder: true,
            selector: (row) => row.year,
            format: (row) => getYearPlaceHolder(row.year),
        });
    }
    columns.push({
        name: "تاريخ انشاء الحساب",
        reorder: true,
        selector: (row) => row.created_at,
        format: (row) => printFullDate(row.created_at),
    });

    const [governments, setGovernments] = useState([]);

    async function getGovernments() {
        const { data } = await http.get("/api/governments");
        setGovernments(data);
    }
    useEffect(() => {
        getGovernments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <Table columns={columns} data={user} />;
};

export default ShowUser;
